let getters = {
  alertMessage(state){
    return state.alertMessage
  },
  foodForThought (state) {
    return state.foodForThought
  },
  availableCreditLimit (state) {
    return state.availableCreditLimit
  },
  creditPauseMsg (state) {
    return state.creditPauseMsg
  },
  creditPaused (state) {
    return state.creditPaused
  },
  daysToFreeze (state) {
    return state.daysToFreeze
  },
  dueTxnCount (state) {
    return state.dueTxnCount
  },
  outstandingAmount (state) {
    return state.outstandingAmount
  },
  overdueTxnCount (state) {
    return state.overdueTxnCount
  },
  unpaidTxnCount (state) {
    return state.unpaidTxnCount
  },
  unsettledTransactionList (state) {
    return state.unsettledTransactionList
  },
  unsettledTransactionIds (state) {
    var transactionIDs = state.unsettledTransactionList.map(function(item){
      return item.id
    })
    return transactionIDs
  }
}
export default getters



// WEBPACK FOOTER //
// ./src/store/home/getters.js